import React from 'react';
import getCurrency from '../../utils/getCurrency';
import { getEffectivePrice } from '../../utils/priceUtils';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import { Tooltip } from '@mui/material';
import { formatBrandName } from '../../utils/format';

const CatalogCard = ({
    product,
    isModalOpenSet,
    modalDataSet
}) => {
    let data = typeof product?.JsonFeedData === "string" && JSON.parse(product?.JsonFeedData);
    let productType = data?.productType?.split(">")?.pop()?.trim();
    const providerBrand = formatBrandName(product?.from || product?.vendor || data?.from || '');
    const sourceProvider = String(product?.from || '').toLowerCase();
    const rawSubBrand = product?.brand || data?.brand || '';
    const normalizedSubBrand = String(rawSubBrand).toLowerCase();
    const showSubBrand = sourceProvider.includes('wayfair') && normalizedSubBrand && normalizedSubBrand !== sourceProvider;
    const hasAdjustedPrice = product?.adjustedPrice != null && product?.adjustedPrice !== '';
    const displayPrice = getEffectivePrice({ price: data?.price, adjustedPrice: product?.adjustedPrice });

    return (
        <div
            onClick={() => {
                isModalOpenSet(true);
                modalDataSet({
                    ...data,
                    adjustedPrice: product?.adjustedPrice,
                    from: product?.from,
                    sourceBrand: product?.brand,
                });
            }}
            className="bg-background-white h-[265px] shadow-lg rounded-lg cursor-pointer flex gap-4 p-6"
        >
            {/** IMAGE */}
            <div className="aspect-square w-1/3 rounded-md overflow-hidden max-h-[300px]">
                <img src={data.image_link} alt={data.title} className="size-full object-cover object-center" />
            </div>

            {/** NAME & DESCRIPTION */}
            <div className="flex flex-col gap-2 flex-1 justify-between">
                <div className="flex flex-col gap-0.5">
                    <div className="text-lg font-semibold">{data.title?.substring(0, 50)} {data.title?.length > 50 ? "..." : ""}</div>
                    <div className="text-primary/50 uppercase">{productType?.substring(0, 50)} {productType?.length > 50 ? "..." : ""}</div>
                    <div className="mt-1 text-sm leading-tight">
                        <span className="font-medium text-primary/80">{providerBrand}</span>
                        {showSubBrand && (
                            <>
                                <span className="mx-1.5 text-primary/30">-</span>
                                <span className="text-xs font-normal text-primary/50">{rawSubBrand}</span>
                            </>
                        )}
                    </div>
                </div>
                <div className="line-clamp-2 text-primary/80">{data.description}</div>

                {/** PRICE: show adjusted price when set, with icon */}
                <div className="flex items-center gap-1.5">
                    <span className="text-lg font-semibold">{getCurrency(displayPrice)}</span>
                    {hasAdjustedPrice && (
                        <Tooltip title="This price was manually adjusted by designer">
                            <span
                                className="inline-flex items-center justify-center rounded-full bg-primary/10 text-primary p-0.5 cursor-help"
                                aria-label="Adjusted price info"
                            >
                                <Info className="w-4 h-4" />
                            </span>
                        </Tooltip>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CatalogCard